import { Heading, Text, Box } from 'rebass';
import React, { useContext } from 'react';

import { HeaderWrap, Header, BlurredHeader, HeaderBottomWrap } from './CoverHeader.sc';
import { StoryContext } from '../../pages/story';
import MemberAvatar from '../MemberAvatar';
import ShareAvatars from './ShareAvatars';
import useCoverImage from '../hooks/useCoverImage';
import useEntity from '../hooks/useEntity';
import useStoryDate from '../hooks/useStoryDate';

const CoverHeader = () => {
  const id = useContext(StoryContext);
  const type = 'stories';
  const story = useEntity({ id, type });
  const member = useEntity({ id: story.member.id, type: 'members' });
  const storyDate = useStoryDate(story);
  const imgSrc = useCoverImage({ id, version: 2 });

  return (
    <HeaderWrap>
      <BlurredHeader img={imgSrc} />
      <Header img={imgSrc}>
        <HeaderBottomWrap>
          <Box flex="0 1 40px">
            <MemberAvatar id={member.id} size={[40, 60, 80]} />
          </Box>
          <Box ml={20}>
            <Heading as="h1" fontFamily="brand" fontSize={[0, 2]}>
              {story.title}
            </Heading>
            {storyDate && (
              <Text textAlign="left" fontSize={[0, 0, 1]} color="white" fontFamily="sans">
                {storyDate}
              </Text>
            )}
          </Box>
          <ShareAvatars truncateAt={4} />
        </HeaderBottomWrap>
      </Header>
    </HeaderWrap>
  );
};

export default CoverHeader;
